import { Row } from '@/components/layout/layout'
import { WithInputLimit } from '@/utils'
import React, { useState } from 'react'
import { createUseStyles, Styles } from 'react-jss'

const useStyles = createUseStyles({
    inputContainer: {
        height: '50px',
        flexShrink: 0,
        borderBottom: '1px solid rgba(0,0,0,0.10)',
    },

    onError: {
        borderBottom: '1px solid #FF4343 !important',
    },

    onFocus: {
        borderBottom: '1px solid #14CC9B',
    },

    input: {
        flex: 1,
        border: 'none',
        outline: 'none',
        fontSize: '14px',
        color: '#000',

        '&::placeholder': {
            color: '#999',
        },
    },

    errorInfo: {
        fontSize: '12px',
        color: '#FF4343',
    },
})

const Input: React.FC<
    {
        error?: boolean
        inputprefix?: () => React.ReactNode
        inputsuffix?: () => React.ReactNode
        wrapClassName?: string
        reg?: RegExp
        styles?: Styles
    } & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
> = props => {
    const styles = useStyles()
    const [isFocus, setFocusStatus] = useState(false)

    const { reg, error, wrapClassName, inputsuffix, inputprefix, ...reset } = props

    const onFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        props.onFocus && props.onFocus(event)
        setFocusStatus(true)
    }

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        props.onBlur && props.onBlur(event)
        setFocusStatus(false)
    }

    return (
        <Row
            data-expaned
            data-align-items-center
            style={{ ...props.styles }}
            className={[
                styles.inputContainer,
                isFocus && styles.onFocus,
                props.wrapClassName,
                props.error && styles.onError,
            ].join(' ')}
        >
            {inputprefix && inputprefix()}
            {props.type !== 'text' ? (
                WithInputLimit(
                    <input
                        {...reset}
                        autoComplete="off"
                        className={[styles.input, props.className].join(' ')}
                        onFocus={onFocus}
                        onBlur={onBlur}
                    />,
                    reg ? reg : /.*/,
                )
            ) : (
                <input
                    {...reset}
                    autoComplete="off"
                    className={[styles.input, props.className].join(' ')}
                    onFocus={onFocus}
                    onBlur={onBlur}
                />
            )}
            {inputsuffix && inputsuffix()}
        </Row>
    )
}

export default Input
